import React from 'react';
import PropTypes from 'prop-types';
import ReadOnlyField from '../ReadOnlyField';

const AccountInfoReadOnly = ({ formData, userCountry }) => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5 mb-6">
      <ReadOnlyField label="Email" value={formData.email} />
      <ReadOnlyField label="First name" value={formData.firstName} />
      <ReadOnlyField label="Last name" value={formData.lastName} />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5 mb-8">
      {userCountry !== undefined && (
        <ReadOnlyField label="Country of residence" value={userCountry} />
      )}
      <ReadOnlyField label="Mobile phone" value={formData.mobilePhone} />
    </div>
  </>
);

AccountInfoReadOnly.propTypes = {
  formData: PropTypes.object.isRequired,
  userCountry: PropTypes.string
};

export default AccountInfoReadOnly;
